import { UserCohort } from 'owa-bizchat-shared/lib/store/store';
import { getUserCohort } from 'owa-bizchat-shared/lib/utils/getUserCohort';
import { getModuleContextMailboxInfo } from 'owa-module-context-mailboxinfo';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

/**
 * This function determines if the user is a Commercial Premium user.
 * This is used in contexts where certain experiments (like SUA Reading Pane Experiment) should only
 * be shown to Commercial Premium users, excluding Starter and MSA users.
 */
export function isUserCommercialPremium(): boolean {
    const mailboxInfo = getModuleContextMailboxInfo();
    const userCohort = getUserCohort(mailboxInfo);
    return !isConsumer() && userCohort === UserCohort.BCAIS;
}
